import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'
import services from '@/services'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version
let searchPreviousRequest = null

export default {
  GET_METADATA: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/utils/info`).then(res => {
        res.body.user_roles = services.removeUnnecessaryRoles(res.body.user_roles)
        commit('SET_METADATA', { origin: res.body, formated: services.formatMetadataForSelect(res.body) })
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_COUNTS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/admin-info`).then(res => {
        commit('UPDATE_TOTALS', res.body)
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_APP_VERSION: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/utils/whats-new`).then(res => {
        commit('SET_APP_VERSIONS', res.body.versions)
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  MAIN_SEARCH: ({ commit, state }, {search, type}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/utils/global-search`, { search_string: search, search_type: type }, {
        // use before callback
        before (request) {
          if (type === state.globalSearchTypes.keywords) {
            // abort previous request, if exists
            if (searchPreviousRequest) {
              searchPreviousRequest.abort()
            }
            // set previous request on Vue instance
            searchPreviousRequest = request
          }
        }
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/metadata/actions.js